import React, { createContext, useContext, useState } from 'react'

const ThemeContext = createContext()

export const useTheme = () => {
  const context = useContext(ThemeContext)
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider')
  }
  return context
}

// Background types - these adapt to the current color theme
export const BACKGROUND_TYPES = {
  GLASS: 'glass',
  BALLS: 'balls',
  LINES: 'lines'
}

export const ThemeProvider = ({ children }) => {
  const [backgroundType, setBackgroundType] = useState(BACKGROUND_TYPES.GLASS)

  const value = {
    backgroundType,
    setBackgroundType,
    BACKGROUND_TYPES
  }

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  )
}

export default ThemeContext